export class TimeAgo {
  static getTimeUnit(value, unit) {
    return value === 1 ? `1 ${unit} ago` : `${value} ${unit}s ago`;
  }

  static format(inputDate) {
    const timeDifference = new Date() - new Date(inputDate);
    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);

    if (years > 0) return this.getTimeUnit(years, 'year');
    if (months > 0) return this.getTimeUnit(months, 'month');
    if (days > 0) return this.getTimeUnit(days, 'day');
    if (hours > 0) return this.getTimeUnit(hours, 'hour');
    if (minutes > 0) return this.getTimeUnit(minutes, 'minute');
    if (seconds > 0) return this.getTimeUnit(seconds, 'second');

    return 'just now';
  }
}
